/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalTurnoElegidoYaFueSeleccionado.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import ModalConfirmacionTurno from '../../../components/Telemedicina/ModalConfirmacionTurno/ModalConfirmacionTurno';
import ModalConfirmacionTurnoResp from '../../../components/Telemedicina/ModalConfirmacionTurnoResp/ModalConfirmacionTurnoResp';
import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';
import Image from '../../../components/Telemedicina/images/medico.png';

class ModalTurnoElegidoYaFueSeleccionado extends React.Component {
  static formatearFecha(fecha) {
    const year = fecha.substring(0, 4);
    const month = fecha.substring(4, 6);
    const day = fecha.substring(6, 8);

    return `${day}/${month}/${year}`;
  }

  static formatearHora(hora) {
    return `${hora.substr(0, 2)}:${hora.substr(2, 4)}`;
  }

  static getDataUser() {
    const auth = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
    let user;
    if (auth) {
      user = {
        email: JSON.parse(auth).modelEspecifico.email,
      };
    }
    return user;
  }

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      dataTurno: '',
      nombreapellido: '',
      especialidad: '',
    };

    this.showModal = this.showModal.bind(this);
  }

  componentDidMount() {
    $('#modalTurnoYaSeleccionado').modal('show');
  }
  componentWillReceiveProps(props) {
    if (this.props.confirmacionTurno !== props.confirmacionTurno) {
      const email = $('#email').val();
      $('#mail').html(email);
      $('#modalConfirmTurnoResp').modal('show');
    }
  }
  showModal(data) {
    $('#modalTurnoYaSeleccionado').modal('hide');
    this.setState({
      dataTurno: data,
      nombre: data.titular.nombreAbre,
      apellido: data.titular.apeRazon,
      especialidad: data.idEspecialidad,
    });
    $('#modalConfirmTurno').modal('show');
  }

  render() {
    // console.log('TURNO PROXIMO');
    // console.log(this.props.proximoTurno);
    return (
      <div>
        <div>
          <ModalConfirmacionTurno
            image={Image}
            nombre={this.state.nombre}
            apellido={this.state.apellido}
            email={ModalTurnoElegidoYaFueSeleccionado.getDataUser().email}
            dataTurno={this.state.dataTurno}
          />
          <div />
          <ModalConfirmacionTurnoResp />
        </div>
        <div className="modal fade" id="modalTurnoYaSeleccionado">
          <div className="modal-dialog">
            <div className={`${s.modalContent} modal-content`}>
              <div className="modal-header">
                <h5 className="modal-title">
                  El turno elegido ya fue seleccionado
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className={`${s.modalBody} modal-body`}>
                <div className="font-weight-bold">
                  Durante la validación alguien tomó tu turno.
                </div>
                <div>El próximo disponible es el</div>
                <div>{`${ModalTurnoElegidoYaFueSeleccionado.formatearFecha(
                  this.props.proximoTurno.fecha,
                )} a las ${ModalTurnoElegidoYaFueSeleccionado.formatearHora(
                  this.props.proximoTurno.hora,
                )} Hs.`}</div>
              </div>
              <div className={`${s.modalFooter} modal-footer`}>
                <button
                  data-dismiss="modal"
                  className={`${s.boton_blanco} btn btn-default`}
                >
                  Seleccionar Otro
                </button>
                <button
                  // data-dismiss="modal"
                  className={`${s.boton_rojo} btn btn-danger`}
                  onClick={() =>
                    // this.props.confirmarTurno(this.props.proximoTurno)}
                    this.showModal(this.props.proximoTurno)}
                >
                  Tomar Turno
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  confirmacionTurno: state.telemedicina.confirmacion_turno,
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(ModalTurnoElegidoYaFueSeleccionado),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalTurnoElegidoYaFueSeleccionado/ModalTurnoElegidoYaFueSeleccionado.js